
import React, { Component } from "react";
import "./style.scss";
import {
  TableWrapper,
  NormalInput,
  NormalFileUpload,
  DragFileUpload,
  SearchInputKeyboard,
} from "component/common";
import {
  getCommonApi,
  updateForm,
  commonCreateApi,
  commonDeleteApi,
  commonPatchApi,
} from "redux/actions/common";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { history } from "helpers";
import { Toast } from "service/toast";
import SimpleReactValidator from "simple-react-validator";
import { MCFormPopup } from "./McFormPopup";

export class McFormClass extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    headerDetails: [
      { label: "Visited Date" },
      { label: "Patient Name " },
      { label: "Document Type" },
      {
        label: "Form",
      },
      { label: "Action" },
    ],

    documentList: [],
    isMCFormOpen: false,
  };
  componentDidMount() {
    this.getCustomerDocument();
  }

  getCustomerDocument = () => {
    let { documentListHeader } = this.state;
    this.props
      .getCommonApi(
        `customerdocument/?customer_id=${this.props.id}&document_type=medical_certificate`
      )
      .then((key) => {
        let { data } = key;
        let { documentList } = this.state;
        documentList = data;

        this.setState({ documentList });
      });
  };

  toggleMCForm = () => {
    this.setState({
      isMCFormOpen: !this.state.isMCFormOpen,
    });
  };

  render() {
    let { headerDetails, documentList = [] } = this.state;
    let { t } = this.props;
    return (
      <div className="treatment-account mt-4">
        <div className="row">
          <div className="col-12 d-flex justify-content-end mb-2">
            <div className="col-3">
              <input
                type="button"
                value="Create MC Form"
                className="btn cursor-pointer mainbg-btn"
                onClick={this.toggleMCForm}
              />
            </div>
          </div>
        </div>
        <div className="col-12 mt-2">
          <div className="table">
            <TableWrapper
              headerDetails={headerDetails}
              //   queryHandler={this.handlePagination}
              // pageMeta={pageMeta}
              // isEmpty={documentList.length === 0 ? true:false}
            >
              {documentList && documentList.length > 0
                ? documentList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div className="text-left">{item.visit_date}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.patient_name}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.document_type}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.pdf_file}</div>
                        </td>
                        <td>
                          <div className="text-left">
                            {/* Download Button */}
                            {item.pdf_file ? (
                              <a
                                href={item?.pdf_file}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-primary"
                              >
                                Download
                              </a>
                            ) : (
                              "-"
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </TableWrapper>
          </div>
        </div>
        <MCFormPopup
          isOpen={this.state.isMCFormOpen}
          toggle={this.toggleMCForm}
          id={this.props.id}
          getDocumentDetails={this.getCustomerDocument}
          t={t}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      updateForm,
      commonCreateApi,
      commonPatchApi,
      commonDeleteApi,
    },
    dispatch
  );
};

export const McForm = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(McFormClass)
);